<template>
  <div class="smb-sales_container">
    <div class="smb-sales_container_title">
      <div class="smb-sales_container_title__left">Admin Account</div>
      <div
        class="smb-sales_container_title__right"
        title="After the partner registered successfully, main contact will become the administrator account"
        v-if="isApply"
      >
        Admin Account will serve as the administrator account for the partner. Please communicate with the partner before filling it in.
      </div>
    </div>
    <div
      class="smb-sales_container_content"
      v-if="isApply"
    >
      <el-form
        ref="form"
        label-position="top"
        :model="formData"
        :rules="rules"
        :validate-on-rule-change="false"
      >
        <div class="smb-sales_grid grid-1x2 gap_80">
          <div class="smb-sales_grid grid-1x2 gap_11">
            <el-form-item prop="firstName">
              <template #label>
                <div class="smbsales-label_required">
                  First Name
                </div>
              </template>
              <el-input
                v-model="formData.firstName"
                @blur="
                  event => (formData.firstName = event.target.value.trim())
                "
              />
            </el-form-item>
            <el-form-item prop="lastName">
              <template #label>
                <div class="smbsales-label_required">
                  Last Name
                </div>
              </template>
              <el-input
                v-model="formData.lastName"
                @blur="event => (formData.lastName = event.target.value.trim())"
              />
            </el-form-item>
          </div>

          <el-form-item prop="email">
            <template #label>
              <div class="smbsales-label_required">
                Work Email
              </div>
            </template>
            <el-input
              v-model.trim="formData.email"
              placeholder=""
              @focus="handleEmailFocus"
              @blur="handleEmailBlur"
            />
          </el-form-item>
        </div>
        <div class="smb-sales_grid grid-1x2 gap_80">
          <el-form-item prop="position">
            <template #label>
              <div class="smbsales-label_required">
                Job Title
              </div>
            </template>
            <el-input
              v-model="formData.position"
              @blur="event => (formData.position = event.target.value.trim())"
            />
          </el-form-item>
          <el-form-item
            prop="isChannelConfirm"
          >
            <template #label>
              <div class="smbsales-label_required">
                Need Partner Confirmation
              </div>
            </template>
            <el-radio-group v-model="formData.isChannelConfirm">
              <el-radio :label="1">Yes</el-radio>
              <el-radio :label="0">No</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div
          class="smb-sales_grid grid-1x2 gap_80"
        >
          <el-form-item prop="officePhone">
            <template #label>
              <div>
                Office Phone
              </div>
            </template>
            <div class="smb-sales_grid grid-1x4 gap_6">
              <el-form-item prop="countryCode">
                <template #label>
                  <div class="smbsales-label">
                    Country Code
                  </div>
                </template>
                <el-input-number
                  :controls="false"
                  :precision="0"
                  :min="0"
                  @change="(val) => handleInputNumberChange(val, 'countryCode')"
                  v-model="formData.countryCode"
                  placeholder="Required"
                />
              </el-form-item>
              <el-form-item prop="stateNumber">
                <template #label>
                  <div class="smbsales-label">
                    State Number
                  </div>
                </template>
                <el-input-number
                  :controls="false"
                  :precision="0"
                  v-model.trim="formData.stateNumber"
                  @change="(val) => handleInputNumberChange(val, 'stateNumber')"
                  placeholder="Optional"
                />
              </el-form-item>
              <el-form-item prop="telephone">
                <template #label>
                  <div class="smbsales-label">
                    Phone Number
                  </div>
                </template>
                <el-input-number
                  :controls="false"
                  :precision="0"
                  v-model.trim="formData.telephone"
                  @change="(val) => handleInputNumberChange(val, 'telephone')"
                  placeholder="Required"
                />
              </el-form-item>
              <el-form-item prop="extension">
                <template #label>
                  <div class="smbsales-label">
                    Extension
                  </div>
                </template>
                <el-input-number
                  :controls="false"
                  :precision="0"
                  v-model.trim="formData.extension"
                  placeholder="Optional"
                  @change="(val) => handleInputNumberChange(val, 'extension')"
                />
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item v-if="checkedUserStatus">
            <template #label>
              <div class="smbsales-label">
                User status
              </div>
            </template>
            <span v-if="checkedUserStatus.relationType === 2">
              This email has been registered and is associated with
              <span
                class="click-span"
                @click="handleOpenNumberOfRelatedContracts"
              >({{ checkedUserStatus.relationCount }}) partner contracts</span
              >.
            </span>
            <span v-else>
              {{ checkedUserStatus.prompt }}
            </span>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="smb-sales_container_table" v-if="!isApply">
      <el-row>
        <el-col :span="12">
          <div class="smb-sales_label">Name</div>
          <div class="smb-sales_value">
            {{ detailData.userName || "-" }}
          </div>
        </el-col>
        <el-col :span="12">
          <div class="smb-sales_label">Work Email</div>
          <div class="smb-sales_value">{{ detailData.masterAccount }}</div>
        </el-col>
      </el-row>
      <div class="smb-sales_tips">
        <img
          src="@/assets/tool-tip_icon.svg"
          width="18px"
          height="18px"
          alt=""
        />
        <div class="smb-sales_desc" style="color: #e60039;">
          If you want to change the administrator account, please operate
          through the 'Change Administrator Account' button on the <span class="click-span" @click="handleToContractList">Contract List page</span>
        </div>
      </div>
    </div>
    <NumberOfRelatedContracts
      :visible.sync="numberOfRelatedContractsVisible"
      :table-list="
        (checkedUserStatus && checkedUserStatus.associatedVOList) || []
      "
    />
  </div>
</template>

<script>
import {verifyMainAccount} from "../../../../../api/international";
import {mapMutations} from "vuex";
import NumberOfRelatedContracts from "./NumberOfRelatedContracts.vue";

export default {
  name: "mainContact",
  components: {NumberOfRelatedContracts},
  props: {
    // 编辑类型 基础 base或者高级senior 默认基础
    isApply: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        position: "",
        isChannelConfirm: 0,
        countryCode: void 0,
        stateNumber: void 0,
        telephone: void 0,
        extension: void 0,
        userStatus: 1 // 主联系人
      },
      checkedUserStatus: void 0,
      numberOfRelatedContractsVisible: false // 合同数量弹窗
    };
  },
  watch: {
    formData: {
      handler(nextFormData) {
        this.SET_MAIN_CONTACT(nextFormData);
      },
      immediate: true,
      deep: true
    },
    "formData.countryCode"() {
      this.$nextTick(() => {
        this.$refs.form.validateField("telephone");
      });
    },
    "formData.stateNumber"() {
      this.$nextTick(() => {
        this.$refs.form.validateField("countryCode");
        this.$refs.form.validateField("telephone");
      });
    },
    "formData.telephone"() {
      this.$nextTick(() => {
        this.$refs.form.validateField("countryCode");
      });
    },
    "formData.extension"() {
      this.$nextTick(() => {
        this.$refs.form.validateField("countryCode");
        this.$refs.form.validateField("telephone");
      });
    }
  },
  computed: {
    rules() {
      let that = this;
      return {
        firstName: [
          {
            required: true,
            message: "please input firstName",
            trigger: ["change"]
          }
        ],
        lastName: [
          {
            required: true,
            message: "please input lastName",
            trigger: ["change"]
          }
        ],
        email: [
          {
            type: "email",
            message: "please input right work email",
            trigger: ["blur"]
          },
          {
            required: true,
            message: "please input work email",
            trigger: ["change"]
          }
        ],
        position: [
          {
            required: true,
            message: "please input job title",
            trigger: ["change"]
          }
        ],
        isChannelConfirm: [
          {
            required: true,
            message: "please select need partner confirmation",
            trigger: ["change"]
          }
        ],
        countryCode: [
          {
            validator(rule, value, callback) {
              if (
                !!that.formData.countryCode ||
                !!that.formData.stateNumber ||
                !!that.formData.telephone ||
                !!that.formData.extension
              ) {
                if (value) {
                  if (value.toString().length > 4) {
                    callback(
                      new Error("Kindly input the accurate country code.")
                    );
                  } else {
                    const countryCodeRegex = /^[1-9][0-9]{0,3}$/; // 1到4位数字的正则表达式
                    if (countryCodeRegex.test(value.toString())) {
                      callback();
                    } else {
                      callback(
                        new Error("Kindly input the accurate country code.")
                      );
                    }
                  }
                } else {
                  callback(new Error("please input country code"));
                }
              } else {
                callback()
              }
            },
            trigger: ["blur"]
          }
        ],
        stateNumber: [
          {
            required: false,
            message: "please input state number",
            trigger: ["blur"]
          }
        ],
        telephone: [
          {
            required:
              !!this.formData.countryCode ||
              !!this.formData.stateNumber ||
              !!this.formData.telephone ||
              !!this.formData.extension,
            message: "please input phone number",
            trigger: ["blur"]
          }
        ],
        extension: [
          {
            required: false,
            message: "please input extension",
            trigger: ["blur"]
          }
        ]
      };
    }
  },
  methods: {
    ...mapMutations("smbSales", ["SET_MAIN_CONTACT"]),
    // 邮箱输入
    handleEmailFocus() {
      this.checkedUserStatus = void 0;
    },
    // 邮箱失去焦点
    handleEmailBlur() {
      // 检验邮箱 检查主账号状态
      this.$refs.form.validateField("email", err => {
        if (err) return;
        verifyMainAccount(this.formData.email).then(response => {
          let {status, data} = response;
          if (Number(status) === 200) {
            this.checkedUserStatus = data;
          }
        });
      });
    },
    // 打开合同数量弹窗
    handleOpenNumberOfRelatedContracts() {
      this.numberOfRelatedContractsVisible = true;
    },
    // 设置formData
    setFormData(formData) {
      if (!formData) return;
      let formDataCopy = JSON.parse(JSON.stringify(formData));
      this.formData = {
        ...formData,
        generalManagerName: formDataCopy.fisrtName + " " + formDataCopy.lastName,
        countryCode: formDataCopy.countryCode || void 0,
        stateNumber: formDataCopy.stateNumber || void 0,
        telephone: formDataCopy.telephone || void 0,
        extension: formDataCopy.extension || void 0
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    // 获取formData
    getFormData() {
      let isPass = false;
      this.$refs.form.validate(isSuccess => {
        isPass = isSuccess;
      });
      if (isPass) {
        let formData = JSON.parse(JSON.stringify(this.formData));
        formData.generalManagerName =
          formData.firstName + " " + formData.lastName;
        if (formData.countryCode && formData.telephone) {
          if (formData.stateNumber && formData.extension) {
            formData.officePhone = `+${formData.countryCode} (${formData.stateNumber}) ${formData.telephone} ext.${formData.extension}`;
          } else if (formData.stateNumber) {
            formData.officePhone = `+${formData.countryCode} (${formData.stateNumber}) ${formData.telephone}`;
          } else if (formData.extension) {
            formData.officePhone = `+${formData.countryCode} ${formData.telephone} ext.${formData.extension}`;
          } else {
            formData.officePhone = `+${formData.countryCode} ${formData.telephone}`;
          }
        }
        return formData;
      } else {
        return isPass;
      }
    },
    handleInputNumberChange(val, type) {
      if (!val || !val.toString().trim()) {
        this.$nextTick(() => {
          this.formData[type] = void 0;
        });
      }
    },
    handleToContractList() {
      this.$router.push("/ContractInfolist");
    }
  }
};
</script>

<style scoped>
.click-span {
  color: #007aff;
  cursor: pointer;
}
.smb-sales_tips {
  margin-top: 18px;
}

</style>



// WEBPACK FOOTER //
// src/views/channelAgreement/twentyTwentyFive/SBG/components/adminAccount.vue